import { Module } from 'vuex';
import { LogsState, RootState } from '@/store/types';
import moment from 'moment';

export const logs: Module<LogsState, RootState> = {
    namespaced: true,
    state: {
        filter: {
            zeitraum: [
                moment().format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD'),
            ],
            loglevel: [],
        },
    },
};
